module.exports = {
  urlPrefix: ``,
  analyticsKey: 'UA-120783685-1',
};
